import $ from 'jquery';
import Util from 'root/module/util';
import Constants from 'root/constants';
import Cache from 'root/cache';
import View from 'view/base';

export const operators = {
    contains: 'contains',
    contains_any: 'contains any',
    is_equal: 'is',
    is_less: 'is less than',
    is_greater: 'is greater than',
    is_not_empty: 'is not empty',
    is_not: 'is not'
};

export default View.extend({
    tagName: 'form',
    className: 'dropdown-region survey-question-condition',

    events: {
        'click .condition-add'               : 'onConditionAdd',
        'click .condition-type li'           : 'onConditionTypeChange',
        'click .survey-question-dropdown li' : 'onQuestionChange',
        'click .search-operator li'          : 'onOperatorChange',
        'click .condition-delete'            : 'onConditionDelete',
        'click .condition-clear'             : 'onConditionClear',
        'click .condition-apply'             : 'onConditionApply',
        'click .multi-select li'             : 'onMultipleValueSelect',
        'click .single-select li'            : 'onSingleValueSelect'
    },

    dom_handlers: {
        onConditionTypeChange: function(e) {
            this.question_condition_type = $(e.currentTarget).data('val');
        },
        onConditionAdd: function(e) {
            var default_question = this.getDefaultQuestion();
            var condition_template = this.renderConditionTemplate(default_question, this.getDefaultOperator(default_question), '');

            $(condition_template).appendTo(this.$el.find('.region-conditions'));

            this.question_condition = this.getConditions();

            this.checkForm();

            // if condition limit is reached, disable add button
            if (this.$el.find('.condition-item').length >= this.condition_limit) {
                this.$el.find('.condition-add').prop('disabled', true);
            }
        },

        onQuestionChange: function(e) {
            const region_operator = $(e.target).closest('.condition-item').find('.question-operator');
            const region_value = $(e.target).closest('.condition-item').find('.search-val');

            // dropdown selected value
            const question_key = $(e.currentTarget).data('val');
            const questions = this.getQuestions().filter(
                (question) => question.get('question_key') === question_key
            );

            if (questions.length) {
                const operator = this.getDefaultOperator(questions[0]);
                region_operator.html(this.renderOperatorOptions(questions[0].get('question_type'), operator, questions[0].get('question_sub_type')));
                region_value.html(this.renderConditionValue(questions[0], ''));
            }
        },

        onConditionDelete: function(e) {
            $(e.currentTarget).parents('.condition-item:first').remove();
            this.checkForm();

            // if condition limit is reached, enable add button
            if (this.$el.find('.condition-item').length < this.condition_limit) {
                this.$el.find('.condition-add').prop('disabled', false);
            }
        },

        onConditionApply: function() {
            var conditions = this.getConditions();
            this.trigger('submit', {
                question_condition_type: this.question_condition_type,
                question_condition: conditions
            });
        },

        onConditionClear: function() {
            this.trigger('submit', {
                question_condition_type: Constants.QUESTION_CONDITION_TYPE_AND,
                question_condition: []
            });
        },

        onMultipleValueSelect: function(e) {
            var selectedValue = $(e.currentTarget).attr('data-val');
            const condition_index = $(e.currentTarget).closest('.condition-item').index();

            var question_condition = this.getConditions(true)[condition_index - 1];

            // if selected value is not in the array, add it, otherwise remove it
            if (question_condition) {
                var question_value = question_condition.value;
                if (Array.isArray(question_value)) {
                    if (question_value.includes(selectedValue)) {
                        question_value = question_value.filter((value) => value !== selectedValue);
                    } else {
                        question_value.push(selectedValue);
                    }
                } else {
                    if (question_value !== selectedValue) {
                        question_value = [question_value, selectedValue];
                    } else {
                        question_value = [];
                    }
                }

                // Shonk: This is a hack to update the dropdown value after the click event
                setTimeout(() => {
                    var region_value = $(e.currentTarget).closest('.condition-item').find('.search-val');
                    region_value.html(this.renderConditionValue(Cache.survey_question.findWhere({question_key: question_condition.key}), question_value, question_condition.operator));
                }, 0);
            }
        },

        onOperatorChange: function(e) {
            // if selected value is is_not_empty, disable .search-val input
            var operator = $(e.currentTarget).data('val');
            var region_value = $(e.currentTarget).closest('.condition-item').find('.search-val');

            var question_key = $(e.currentTarget).closest('.condition-item').find('.search-key li.selected').data('val');
            var question = Cache.survey_question.findWhere({question_key: question_key});

            if (question) {
                region_value.html(this.renderConditionValue(question, '', operator));
            }

            if (operator === 'is_not_empty') {
                region_value.find('input').prop('disabled', true);
                region_value.find('button').prop('disabled', true);
            } else {
                region_value.find('input').prop('disabled', false);
                region_value.find('button').prop('disabled', false);
            }
        }
    },

    initialize: function(options) {
        this.question_condition_type = options.question_condition_type || Constants.QUESTION_CONDITION_TYPE_AND;
        this.question_condition = options.question_condition || [];
        this.condition_limit = options.condition_limit || 10;
    },

    // Get the conditions from the form, allow_empty_value is used to get conditions even if the value is empty
    getConditions: function(allow_empty_value = false) {
        var conditions = [];

        this.$el.find('.condition-item').each((index, element) => {
            var condition_key      = $(element).find('.search-key li.selected').data('val');
            var condition_operator = $(element).find('.search-operator li.selected').data('val');
            // if there is dropdown-select, get selected li value, otherwise get input value
            var condition_value    = '';
            if ($(element).find('.search-val .button-dropdown').length) {
                // only dropdown and multiple select has multiple values
                if ($(element).find('.search-val .button-dropdown .multi-select').length) {
                    condition_value = [];
                    $(element).find('.search-val .multi-select li.selected').map((index, el) => {
                        condition_value.push($(el).attr('data-val'));
                    });
                } else {
                    condition_value = $(element).find('.search-val li.selected').attr('data-val');
                }
            } else {
                condition_value = $(element).find('.search-val input').val().trim();
            }

            // check condition key is right. If not, skip this condition
            var question = Cache.survey_question.findWhere({question_key: condition_key});
            if (question) {
                if (allow_empty_value ||
                    (
                        (!Array.isArray(condition_value) && (condition_value || condition_value === 0)) ||
                        (Array.isArray(condition_value) && condition_value.length) ||
                        condition_operator === 'is_not_empty'
                    )
                ) {
                    var question = Cache.survey_question.findWhere({question_key: condition_key});
                    conditions.push({
                        key: condition_key,
                        operator: this.validateOperator(question, condition_operator),
                        value: condition_operator === 'is_not_empty' ? '' : condition_value
                    });
                };
            }
        });

        return conditions;
    },

    checkForm: function() {
        this.$el.find('.condition-delete').prop('disabled', this.$el.find('.condition-item').length <= 1);
    },

    getDefaultOperator: function(question) {
        switch(question.get('question_type')) {
            case 'nps':
            case 'rating':
            case 'yesno':
                return 'is_equal';
            case 'multiple':
            case 'dropdown':
                return 'contains_any';
            default:
                return 'contains';
        }
    },

    getDefaultValue: function(question) {
        switch(question.get('question_type')) {
            case 'nps':
                return 0;
            case 'rating':
                return 1;
            case 'multiple':
            case 'dropdown':
                var opens = JSON.parse(question.get('question_options'));
                return opens.length ? opens[0] : '';
            case 'yesno':
                return 'yes';
            default:
                return '';
        }
    },

    getQuestions: function() {
        // filter out the questions thank_you, welcome, short and long text
        return Cache.survey_question.models.filter((question) => {
            return ['thankyou', 'welcome'].indexOf(question.get('question_type')) === -1;
        });
    },

    renderOperatorOptions: function(question_type, operator, question_sub_type) {
        var operator_options = '';

        if (question_type === 'dropdown' || question_type === 'multiple') {
            operator_options += '<li data-val="contains_any"' + (operator === 'contains_any' ? ' class="selected"' : '') + '>' + operators.contains_any + '</li>';
        } else if (question_type === 'nps' || question_type === 'rating') {
            operator_options += '<li data-val="contains_any"' + (operator === 'contains_any' ? ' class="selected"' : '') + '>' + operators.contains_any +'</li>';
            operator_options += '<li data-val="is_equal"' + (operator === 'is_equal' ? ' class="selected"' : '') + '>' + operators.is_equal +'</li>';
            operator_options += '<li data-val="is_not"' + (operator === 'is_not' ? ' class="selected"' : '') + '>'+ operators.is_not +'</li>';

            if (question_sub_type !== 'thumb') {
                operator_options += '<li data-val="is_less"' + (operator === 'is_less' ? ' class="selected"' : '') + '>' + operators.is_less + '</li>';
                operator_options += '<li data-val="is_greater"' + (operator === 'is_greater' ? ' class="selected"' : '') + '>' + operators.is_greater + '</li>';
            }
        } else if (question_type === 'short' || question_type === 'long') {
            operator_options += '<li data-val="contains"' + (operator === 'contains' ? ' class="selected"' : '') + '>' + operators.contains + '</li>';
        } else {
            // yes no
            operator_options += '<li data-val="is_equal"' + (operator === 'is_equal' ? ' class="selected"' : '') + '>'+ operators.is_equal +'</li>';
            operator_options += '<li data-val="is_not"' + (operator === 'is_not' ? ' class="selected"' : '') + '>'+ operators.is_not +'</li>';
        }

        operator_options += '<li data-val="is_not_empty"' + (operator === 'is_not_empty' ? ' class="selected"' : '') + '>' + operators.is_not_empty + '</li>';

        var content =
        '<div class="search-operator button-dropdown button-dropdown-left button-dropdown-large" data-update="true" data-append="true">' +
            '<button type="button" class="dropdown-select">' + (operators[operator] || operators.contains) + '</button>' +
            '<div>' +
                '<ul class="dropdown dropdown-select">' + operator_options + '</ul>' +
            '</div>' +
        '</div>';

        return content;
    },

    renderConditionTemplate: function(selected_question, operator, question_value) {
        if (!selected_question) {
            return '';
        }

        var survey_questions = '';
        this.getQuestions().forEach((question) => {
            const question_key = question.get('question_key');

            survey_questions +=
            '<li data-val="'+ question_key +'"' + (selected_question.get('question_key') === question_key ? ' class="selected"' : '') + '>' +
                '<span class="question-icon" data-type="' + question.get('question_type') + '">' +
                    Util.htmlEntities(question.getLabel()) +
                '</span>' +
            '</li>';
        });

        var template =
        '<div class="condition-item">' +
            '<button type="button" class="condition-delete small square round text-icon"><i class="fa-solid fa-circle-minus"></i></button>' +
            '<div>' +
                '<div class="search-key button-dropdown button-dropdown-left button-dropdown-full" data-update="true" data-append="true">' +
                    '<button type="button" class="dropdown-select">' +
                        '<span class="question-icon" data-type="' + selected_question.get('question_type') + '">' +
                            Util.htmlEntities(selected_question.getLabel()) +
                        '</span>' +
                    '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select survey-question-dropdown">' +
                            survey_questions +
                        '</ul>' +
                    '</div>' +
                '</div>' +
                '<div class="question-operator">' + this.renderOperatorOptions(selected_question.get('question_type'), operator, selected_question.get('question_s')) + '</div>' +
                '<div class="search-val">' + this.renderConditionValue(selected_question, question_value, operator) + '</div>' +
            '</div>' +
        '</div>';

        return template;
    },

    renderConditionValue: function(question, question_value, operator = '') {
        var content = '';
        var select_placeholder = '<span class="placeholder-text">Select...</span>';
        if (!question) {
            return '';
        }

        if (question.get('question_type') === 'nps' || question.get('question_type') === 'rating') {
            var options = [];
            switch (question.get('question_type')) {
                case 'nps':
                    options = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
                    break;
                case 'rating':
                    switch (question.get('question_sub_type')) {
                        case 'number':
                        case 'star':
                        case 'heart':
                            if (question.get('scale') === 5) {
                                options = [1, 2, 3, 4, 5];
                            } else if (question.get('scale') === 10) {
                                options = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
                            }
                            break;
                        case 'face':
                            options = [1, 2, 3, 4, 5];
                            break;
                        case 'thumb':
                            options = [1, 2];
                            break;
                    }
                    break;
            }

            var option_list = [];
            if (operator === 'contains_any') {
                question_value = Array.isArray(question_value) ? question_value : (typeof question_value === 'string' && question_value ? [question_value] : []);
                option_list = options.map((option) => {
                    return '<li data-val="' + Util.htmlEntities(option) + '"' + (question_value.includes(option?.toString()) ? ' class="selected"' : '') + '>' + Util.htmlEntities(option) + '</li>'
                }).join('');
            } else {
                option_list = options.map((option) => {
                    // thumb nails show emoji
                    var option_label = question.get('question_sub_type') === 'thumb' ? (option === 1 ? '👍' : '👎') : option;
                    return '<li data-val="' + Util.htmlEntities(option) + '"' + (question_value === option?.toString() ? ' class="selected"' : '') + '>' + Util.htmlEntities(option_label) + '</li>'
                }).join('');
            }

            var button_label = '';
            if (operator === 'contains_any') {
                button_label = question_value.length > 0 ? (question_value.length + ' selected') : select_placeholder;
            } else {
                button_label = (question_value || question_value === 0) ? Util.htmlEntities(question_value) : select_placeholder;
            }

            content =
            '<div class="question-condition-value button-dropdown button-dropdown-full" data-update="true" data-append="true">' +
                '<button type="button" class="dropdown-select">' + button_label + '</button>' +
                '<div>' +
                    '<ul class="dropdown dropdown-select ' + (operator === 'contains_any' ? 'multi-select' : 'single-select') + '">' + option_list + '</ul>' +
                '</div>' +
            '</div>';
        } else if (['multiple', 'dropdown', 'yesno'].includes(question.get('question_type'))) {
            // check whether question_value is an array, if not, return
            question_value = Array.isArray(question_value) ? question_value : (typeof question_value === 'string' && question_value ? [question_value] : []);

            var options = question.get('question_type') === 'yesno' ? ['Yes', 'No']: JSON.parse(question.get('question_options'));

            var option_list = options.map((option) => {
                return '<li data-val="' + Util.htmlEntities(option) + '"' + (question_value.includes(option) ? ' class="selected"' : '') + '>' + Util.htmlEntities(option) + '</li>'
            }).join('');


            var button_label = '';
            if (question.get('question_type') === 'yesno') {
                button_label = question_value.length > 0 ? question_value[0] : select_placeholder;
            } else {
                button_label = question_value.length > 0 ? (question_value.length + ' selected') : select_placeholder;
            }

            content =
            '<div class="question-condition-value button-dropdown button-dropdown-full" data-update="true" data-append="true">' +
                '<button type="button" class="dropdown-select">' + button_label + '</button>' +
                '<div>' +
                    '<ul class="dropdown dropdown-select ' + (question.get('question_type') === 'yesno' ? 'single-select' : 'multi-select') + '">' + option_list + '</ul>' +
                '</div>' +
            '</div>';
        } else {
            content = '<input type="text" class="solid compact"' + (question_value ? ' value="' + Util.htmlEntities(question_value) + '"' : '') + '>';
        }

        return content;
    },

    getDefaultQuestion: function() {
        if (this.getQuestions().length) {
            return this.getQuestions()[0];
        }
        return null;
    },

    validateOperator: function(question, operator) {
        // check if operator is valid for the question type
        // if not return the default operator
        if (question.get('question_type') === 'nps' || question.get('question_type') === 'rating' || question.get('question_type') === 'yesno'){
            if (operator === 'contains') {
                return 'is_equal';
            }
        } else if (question.get('question_type') === 'multiple' || question.get('question_type') === 'dropdown') {
            if (operator === 'is_equal' || operator === 'is_less' || operator === 'is_greater' || operator === 'contains') {
                return 'contains_any';
            }
        } else {
            if (operator === 'is_equal' || operator === 'is_less' || operator === 'is_greater') {
                return 'contains';
            }
        }

        return operator;
    },

    render: function() {
        var default_question = this.getDefaultQuestion();
        var condition_options = '';
        this.question_condition.forEach((condition) => {
            // Get question object by key
            const question = this.getQuestions().filter((question) => question.get('question_key') === condition?.key);

            if (question.length) {
                // validate operator
                condition_options += this.renderConditionTemplate(question[0], this.validateOperator(question[0], condition.operator), condition.value);
            }
        });

        if (!condition_options) {
            condition_options = this.renderConditionTemplate(default_question,  this.getDefaultOperator(default_question), '');
        }

        const content =
        '<div class="region-conditions">' +
            '<div class="margin-bottom-12">When ' +
                '<div class="condition-type button-dropdown button-dropdown-left" data-update="true" data-append="true">' +
                    '<button type="button" class="dropdown-select">All</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select">' +
                            '<li data-val="' + Constants.QUESTION_CONDITION_TYPE_AND + '">All</li>' +
                            '<li data-val="' + Constants.QUESTION_CONDITION_TYPE_OR + '">Any</li>' +
                        '</ul>' +
                    '</div>' +
                '</div>' +
            ' of the conditions match</div>' +
            condition_options +
        '</div>' +
        '<div class="region-actions">' +
            '<button type="button" class="condition-add text-primary-small"><i class="fa-solid fa-circle-plus"></i>Add condition</button>' +
            '<div class="margin-top-24">' +
                '<button type="submit" class="condition-apply primary small min">Apply</button>' +
                '<button type="button" class="condition-clear tertiary small min margin-left-8">Clear</button>' +
            '</div>' +
        '</div>';

        this.$el.html(content);

        this.$el.find('.condition-type > button').text(this.question_condition_type === Constants.QUESTION_CONDITION_TYPE_AND ? 'All' : 'Any');
        this.$el.find('.condition-type li[data-val="' + this.question_condition_type + '"]').addClass('selected');

        // disable the .search-val input if operator is is_not_empty
        this.$el.find('.condition-item').each((index, element) => {
            var operator = $(element).find('.search-operator li.selected').data('val');
            var region_value = $(element).find('.search-val');

            if (operator === 'is_not_empty') {
                region_value.find('input').prop('disabled', true);
                region_value.find('button').prop('disabled', true);
            }
        });

        this.checkForm();

        return this;
    }
});